import PropTypes from "prop-types";
import { useMemo } from "react";

import { ErrorToast, ListItemLoader } from "@features/ui";
import { EmptyArray } from "@lib/app.helpers";

import { useInstitutions } from "../api/use-institutions";
import { InstitutionItem } from "./institution-item";

export const InstitutionList = ({
  careerId,
  isRelevantToCareer,
  onInstitutionClick,
}) => {
  const {
    data: institutions,
    isError: isInstitutionsError,
    isPending: isInstitutionsPending,
  } = useInstitutions(careerId);

  const filteredInstitutions = useMemo(
    () =>
      institutions?.filter((institution) =>
        isRelevantToCareer ? institution.isRelevantToCareer : true,
      ) ?? [],
    [institutions, isRelevantToCareer],
  );

  if (isInstitutionsPending) {
    return EmptyArray(2).map((_, index) => (
      <ListItemLoader key={`institution.${index}`} />
    ));
  } else if (isInstitutionsError) {
    return (
      <div className="error-container">
        <ErrorToast
          open
          message="Not currently available. Please try again later."
        />
      </div>
    );
  }

  if (filteredInstitutions.length === 0) {
    return (
      <div className="error-container">
        <ErrorToast
          open
          message={
            isRelevantToCareer
              ? "No best matches found for this career"
              : "No institutions found near you"
          }
        />
      </div>
    );
  }

  return filteredInstitutions.map((institution, index) => (
    <InstitutionItem
      key={institution.name}
      index={index}
      institution={institution}
      showPrograms={isRelevantToCareer}
      onClick={onInstitutionClick}
    />
  ));
};

InstitutionList.displayName = "Institutions List";

InstitutionList.propTypes = {
  careerId: PropTypes.number,
  isRelevantToCareer: PropTypes.bool,
  onInstitutionClick: PropTypes.func,
};
